<template>
  <div
    class="row pt-1"
    v-if="zimmerRecht('read')"
  >
    <div class="col-lg-12">
      <div class="tile-categorie-frame">
        <div class="tile-categorie">
          <div class="header">
            <span>{{ $t("global.roomallocation") }}</span>
          </div>
          <div class="body">
            <div class="row">
              <div :class="kachelCol">
                <div class="tile-frame h-1" :class="kachelStyle">
                  <router-link :to="{ name: 'hotelkontingent-liste' }">
                    <div class="tile bg-turkis inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon icon="fa-duotone fa-building" transform="left-2 shrink-2" />
                      </div>
                      <div class="title">{{ $t("global.hotelquotas") }}</div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div :class="kachelCol">
                <div class="tile-frame h-1" :class="kachelStyle">
                  <router-link :to="{ name: 'zimmerreservation-liste' }">
                    <div class="tile bg-turkis inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon icon="fa-solid fa-list" transform="left-2 shrink-2" />
                      </div>
                      <div class="title">{{ $t("global.roomreservations") }}</div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Startseiten-Kacheln der Zimmereinteilung (Hotelkontingente, Zimmerreservationen).
 * Wird über das Dashboard-JSON des Mitarbeiters eingebunden (name: "startseite-zimmer-reservation").
 */
export default {
  name: "StartseiteZimmerReservation",
  props: {
    kachelStyle: { type: String },
    kachelCol: { type: String },
    kachelKleinStyle: { type: String },
    kachelKleinCol: { type: String },
  },
};
</script>
